import Vue from "vue"
import App from "./App.vue"

Vue.use(require("vue-resource"))

new Vue({
  el: "#checkout_pickup_location_select",
  render: h => h(App)
}) 



// WEBPACK FOOTER //
// ./src/main.js